import React, { useMemo, useState } from 'react'
import PricingItem from '../PricingItems'
import BillList from '../BillList'
import { useTranslation } from 'react-i18next'
import usePayement from '../../Hooks/usePayementHook'
import { STATUS_MAP } from '@/data/status'
import { CRButton, CRRender } from '@/components/crRender'
import { Checkbox } from '@/components/Exporter'

const shownItems = (quotationData, sPS, sAddOns) => ({
    postServices: quotationData?.postServices?.filter(item => sPS.includes(item.id)) || [],
    addOns: quotationData?.addOns?.filter(item => sAddOns.includes(item.id)) || [],
})

const PaymentInfo = ({ quotationData, scheduledDate, selectedAddOns, selectedPostServices }) => {

    const { t } = useTranslation();

    const { postServices, addOns } = shownItems(quotationData, selectedPostServices, selectedAddOns);

    const totalPostServices = useMemo(() => postServices?.reduce((sum, ps) => sum + ps.price, 0), [postServices]);

    const totalPrice = useMemo(() => {

        let totalPaidAddOns = addOns?.reduce((sum, addon) => sum + addon.price, 0) || 0;
        let totalPaidPostServices = postServices?.reduce((sum, ps) => sum + ps.price, 0) || 0;

        return Number(quotationData?.totalPrice) + Number(totalPaidAddOns) + Number(totalPaidPostServices);
    }, [quotationData, addOns, postServices]);

    const ShownAmountToPay = useMemo(() => {
        
        if (![STATUS_MAP.RequestSubmitted, STATUS_MAP.QuotationAvailable, STATUS_MAP.AwaitingInitialPayment, STATUS_MAP.RequestClosed].includes(quotationData?.orderStatusId)) {
           console.log("1",quotationData?.pendingPaymentAmount, totalPostServices);
            return Math.ceil(quotationData?.pendingPaymentAmount + Number(totalPostServices));
        }
        if (STATUS_MAP.AwaitingInitialPayment == quotationData?.orderStatusId) {
            console.log("2",quotationData?.totalPrice, Number(parseInt(quotationData?.paymentPercentage)));
            return Math.ceil(Number(quotationData?.totalPrice) * (Number(parseInt(quotationData?.paymentPercentage)) / 100));
        }
        if(STATUS_MAP.QuotationAvailable == quotationData?.orderStatusId){
            console.log("3",totalPrice, quotationData?.paymentPercentage);
            return Math.ceil((Number(totalPrice)) * (Number(quotationData?.paymentPercentage) / 100));
        }

    }, [quotationData, totalPostServices , totalPrice, quotationData?.paymentPercentage])


    const { onPay, loading, isDisabled, setIsAgreeToTerms, isAgreeToTerms } = usePayement({
        selectedAddOns,
        quotationData,
        scheduledDate,
        downPayment :ShownAmountToPay,
        selectedPostServices
    });

    return (
        <div className="qd-right-column">
            <div className="qd-summary-card">
                <h2 className="qd-summary-title">{t("Total Summary")}</h2>

                <PricingItem title={"Base Quotation"} price={quotationData?.price} />

                <PricingItem title={"Add-ons"} isRender={!!quotationData?.addsOnPrice} price={quotationData?.addsOnPrice} detailsList={quotationData?.addOns.filter(item => !!item.isSelected)} />

                <BillList title={"submited-add-ons"} List={addOns} />

                <PricingItem title={"-postServices"} detailsList={quotationData?.postServices.filter(item => !!item.isSelected)} isRender={!!quotationData?.postServicePrice} price={quotationData?.postServicePrice} />

                <BillList title={"submited-postServices"} List={postServices} />

                <PricingItem title={"Total Price"} isRender={!!totalPrice} price={totalPrice} />

                <PricingItem title={"Paid Price"} isRender={!!quotationData?.paidPrice} price={quotationData?.paidPrice} />

                <CRRender isRender={STATUS_MAP.QuotationAvailable == quotationData?.orderStatusId}>

                    <PricingItem title={`Down Payment ${Number(quotationData?.paymentPercentage) || 0}%`} price={ShownAmountToPay} />

                    <div className="qd-agreement">
                        <Checkbox
                          className={'relative-btn'} typeId={isAgreeToTerms ? 1 : 0}  itemsList={[1, 0]} onApply={() => setIsAgreeToTerms(!isAgreeToTerms)}/>
                        <span>{t("I have read and agree to the refund and payment policies.")}</span>
                    </div>
                    <CRButton className="qd-accept-btn" disabled={isDisabled} loading={loading} title={`${t("Accept & Proceed")} ${ShownAmountToPay}`} onClick={onPay} />
                </CRRender>

                <CRButton isRender={STATUS_MAP.QuotationAvailable != quotationData?.orderStatusId }
                    className="qd-accept-btn" disabled={isDisabled}
                    loading={loading} title={`${t("Proceed to payment")} ${ShownAmountToPay}`}
                    onClick={onPay} />
            </div>
        </div>)
}

export default PaymentInfo